import { configureStore } from "@reduxjs/toolkit";

import productsReviewReducer from "./Redux/products review/slice";
import eCommerceProductsReducer from "./Redux/ecommersProduct/slice";
import eCommerceAdsReducer from "./Redux/E-commerce Ads Model/slice";
import customerCmsApisReducer from "./Redux/admin-cms/customer-cms-apis/slice";
import testimonialsReducer from "./Redux/custmorTestimonials/slice";
import ecommerceTestimonialsReducer from "./Redux/custmorTestimonials/ecommer-tesimonail/slice";
import communityGroupsReducer from "./Redux/Community Groups/group/slice";
import groupMessagesReducer from "./Redux/Community Groups/group-message/slice";
import customerAuthReducer from "./Redux/custmoer_auth/slice";
import customerAddressReducer from "./Redux/customer-address/slice";
import customerCartReducer from "./Redux/custmoer_cart_service/slice";
import checkoutReducer from "./Redux/Custmoer_Checkout/slice";
import customerOrdersReducer from "./Redux/custmoer_orders/slice";
import filtersReducer from "./Redux/filters/slice";
import searchReducer from "./Redux/Search_apis/slice";
import activityReducer from "./Redux/ActivityApi/slice";
import walletReducer from "./Redux/wallet_apis/slice";
import transferReducer from "./Redux/Fund-Transfer-api/slice";

import portfolioReducer from "./Redux/Portfolio/slice";
import referralReducer from "./Redux/referral/slice";
import storeLikeReducer from "./Redux/store_like/slice";

import customerKycReducer from "./Redux/customer_kyc/slice";
import referralProductReducer from "./Redux/RefProduct/slice";
import luckyDrawReducer from "./Redux/luckydraw/slice";
import teamsReducer from "./Redux/Teams/slice";
import storeReviewReducer from "./Redux/storeReview/slice";
import locationReducer from "./Redux/location-mangment/slice";
import deliveryLocationReducer from "./Redux/delivery-location/slice";
import storefrontAdsReducer from "./Redux/storefront-ads/slice";
import digitalProductReducer from "./Redux/digital-product/slice";
import segmentReducer from "./Redux/publicseller-apis-for-bookings/slice";
import shippingReducer from "./Redux/shipping-apis/slice";
import chatReducer from "./Redux/chat/slice";
import ecomCatalogReducer from "./Redux/ecomCatalog/slice";
import buyAgainReducer from "./Redux/buyAgain/slice";

export const store = configureStore({
  reducer: {
    productsReview: productsReviewReducer,
    eCommerceProducts: eCommerceProductsReducer,
    eCommerceAds: eCommerceAdsReducer,
    customerCmsApis: customerCmsApisReducer,
    testimonials: testimonialsReducer,
    ecommerceTestimonials: ecommerceTestimonialsReducer,
    communityGroups: communityGroupsReducer,
    groupMessages: groupMessagesReducer,
    customerAuth: customerAuthReducer,
    customerAddress: customerAddressReducer,
    customerCart: customerCartReducer,
    checkout: checkoutReducer,
    customerOrders: customerOrdersReducer,
    filters: filtersReducer,
    search: searchReducer,
    activity: activityReducer,
    wallet: walletReducer,
    transfer: transferReducer,
    portfolio: portfolioReducer,
    referral: referralReducer,
    storeLike: storeLikeReducer,
    customerKyc: customerKycReducer,
    refProduct: referralProductReducer,
    luckyDraw: luckyDrawReducer,
    teams: teamsReducer,
    storeReview: storeReviewReducer,
    location: locationReducer,
    deliveryLocation: deliveryLocationReducer,
    storefrontAds: storefrontAdsReducer,
    digitalProduct: digitalProductReducer,
    segment: segmentReducer,
    shipping: shippingReducer,
    chat: chatReducer,
    ecomCatalog: ecomCatalogReducer,
    buyAgain: buyAgainReducer,
  },
});

// Types for hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
